export default "/images/ac40108a27b3b0e33ac4cb4a053d3e18.jpg";